import Beatmap from './Beatmap';
import './BeatmapCollection.css';
import LoadingSpinner from '../UI/LoadingSpinner';
import { useRef, useState } from 'react';

let opened = false;
let loading = false;
let errorTimeout;
function BeatmapCollection(props) {
  let loaded = true;
  const [loadingError, setLoadingError] = useState(false);

  const buttonRef = useRef();

  function startErrorCheck() {
    errorTimeout = setTimeout(() => {
      if (loading === true) {
        loaded = true;
        loading = false;
        opened = false;
        setLoadingError(true);
      }
    }, 10000);
  }

  const sets = props.mapList.map((batch, i) => {
    if (loading) {
      try {
        props.set !== undefined &&
        props.maps.length >= props.mapList[props.set][1].length
          ? (loaded = true) && (loading = false)
          : (loaded = false);
      } catch (error) {
        console.log('No set selected');
      }
    }

    function loadMaps() {
      setLoadingError(false);
      clearTimeout(errorTimeout);
      if (!opened) {
        opened = true;
        loaded = false;
        loading = true;
        startErrorCheck(batch, props.set);
        props.load(i);
      } else if (opened && batch[0] === props.set) {
        loaded = true;
        loading = false;
        opened = false;
        props.clear();
      } else {
        opened = true;
        loaded = false;
        loading = true;
        props.load(i);
      }
    }

    let maps = props.maps.map((beatmap) => {
      return (
        <Beatmap
          name={beatmap.set.title}
          artist={beatmap.set.artist}
          mapper={beatmap.set.creator}
          beatmap={beatmap.version}
          key={beatmap.id}
          diffID={beatmap.id}
          download={beatmap.beatmapset_id}
          image={`https://assets.ppy.sh/beatmaps/${beatmap.beatmapset_id}/covers/cover.jpg`}
          diff={beatmap.difficulty_rating}
        />
      );
    });

    return (
      <div key={batch[0]}>
        <div className="batch-button">
          <div
            className={`title ${
              batch[0] === props.set && maps ? 'fullWidth' : ''
            }`}
          >
            <button
              onClick={loaded === true ? loadMaps : () => {}}
              style={{ backgroundPositionX: `${(batch[0] + 3.7) * 5}%` }}
              ref={buttonRef}
            >
              {batch[0] === props.set && maps ? '▼' : '▶'} Batch {batch[0] + 1}
            </button>
          </div>
        </div>
        <div>
          <div className="beatmap-collection">
            {loaded === true && opened === true
              ? batch[0] === props.set && maps
              : batch[0] === props.set &&
                opened && (
                  <div className="loading">
                    Loading... <LoadingSpinner />
                  </div>
                )}
            {props.rateLimitExceeded && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  backgroundColor: 'transparent',
                }}
              >
                <p style={{ color: 'red', textAlign: 'center' }}>
                  Rate limit exceeded, please try again later.
                </p>
              </div>
            )}
          </div>
          {loadingError && batch[0] === props.set && (
            <div>
              <p style={{ color: 'red', textAlign: 'center' }}>
                Error loading maps, please try again.
              </p>
            </div>
          )}
        </div>
      </div>
    );
  });

  return <>{sets}</>;
}

export default BeatmapCollection;
